import { render, staticRenderFns } from "./PaymentCallback.vue?vue&type=template&id=55555d13"
import script from "./PaymentCallback.vue?vue&type=script&lang=js"
export * from "./PaymentCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports